import React from "react";

const Certificates = () => {
  const certificateData = [
    {
      id: 1,
      title: "Build wordpress websites",
      image: "/certificates/1.png",
    },
    {
      id: 2,
      title: "Lean six sigma in SE",
      image: "/certificates/2.png",
    },
    {
      id: 3,
      title: "Postman student certification ",
      image: "/certificates/3.png",
    },
    {
      id: 4,
      title: "JS practicals crash course",
      image: "/certificates/4.png",
    },
    {
      id: 5,
      title: "Machine Learning with YOLOv9",
      image: "/certificates/5.png",
    },
    { id: 6, title: "HTML hero course", image: "/certificates/6.png" },
    { id: 7, title: "VueJS to mastery", image: "/certificates/7.png" },
    {
      id: 8,
      title: "CSS and javascript course",
      image: "/certificates/8.png",
    },
    { id: 9, title: "ReactApp from scratch", image: "/certificates/9.png" },
    {
      id: 10,
      title: "WEB3 essentials",
      image: "/certificates/10.png",
    },
    {
      id: 11,
      title: "HTML5 and CSS3",
      image: "/certificates/11.png",
    },
    { id: 12, title: "Javascript Fundamentals", image: "/certificates/12.png" },
    {
      id: 13,
      title: "CSS hackerrank",
      image: "/certificates/13.png",
    },
    {
      id: 14,
      title: "Problem Solving hackerrank",
      image: "/certificates/14.png",
    },
    {
      id: 15,
      title: "SQL hackerrank",
      image: "/certificates/15.png",
    },
    {
      id: 16,
      title: "Mastering React: React Crash Course",
      image: "/certificates/16.png",
    },
    {
      id: 17,
      title: "Java Training Crash Course",
      image: "/certificates/22.png",
    },
    {
      id: 18,
      title: "React With Redux",
      image: "/certificates/17.png",
    },
    {
      id: 19,
      title: "GIT, GitLab, GitHub for Software Developers",
      image: "/certificates/18.png",
    },
    {
      id: 20,
      title: "Web Development By SoloLearner",
      image: "/certificates/19.jpg",
    },
    {
      id: 21,
      title: "MongoDB Schema Design Patterns and Antipatterns",
      image: "/certificates/20.png",
    },
    {
      id: 22,
      title: "Javascript, jQuery & TypeScript: Full-Stack Web",
      image: "/certificates/21.png",
    },

    {
      id: 23,
      title: "Amazon Web Services (AWS) Certified",
      image: "/certificates/23.png",
    },
  ];

  const handleImageError = (e) => {
    console.error(`Failed to load image: ${e.target.src}`);
    e.target.onerror = null;
    e.target.src = "public/certificates/placeholder-certificate.png";
  };

  return (
    <div
      style={{
        padding: "0px 5%",
        maxWidth: "1400px",
        margin: "0 auto",
      }}
    >
      {/* <h2
        style={{
          fontSize: "2rem",
          marginBottom: "2rem",
          color: "#333",
          textAlign: "center",
        }}
      >
        My Certifications
      </h2> */}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: "2rem",
          padding: "20px 0",
        }}
      >
        {certificateData.map((cert) => (
          <div
            key={cert.id}
            style={{
              background: "#fff",
              borderRadius: "12px",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              overflow: "hidden",
              transition: "transform 0.3s ease",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            <div
              style={{
                width: "100%",
                height: "300px",
                overflow: "hidden",
              }}
            >
              <img
                src={cert.image}
                alt={cert.title}
                style={{
                  width: "100%",
                  height: "100%",
                }}
                onError={handleImageError}
              />
            </div>
            <div
              style={{
                padding: "1.5rem",
                background: "#fff",
              }}
            >
              <h4
                style={{
                  fontSize: "1.1rem",
                  color: "#2d3748",
                  marginBottom: "0.5rem",
                  fontWeight: "600",
                }}
              >
                {cert.title}
              </h4>
              <p
                style={{
                  color: "#718096",
                  fontSize: "0.9rem",
                  marginTop: "0.5rem",
                }}
              >
                Certificate {cert.id.toString().padStart(2, "0")}
              </p>
            </div>
          </div>
        ))}
      </div>
      <p
        style={{
          color: "#808080",
          lineHeight: "1.6",
          marginBottom: "2rem",
          marginTop: "3%",
        }}
      >
        To check original copies of all these certificates please visit to my
        linkedin profile.
      </p>
    </div>
  );
};

export default Certificates;
